
import { useState, createContext, useContext } from "react";
import { Link , NavLink  } from "react-router-dom";
import  { WebAssetsContext }  from "../../../App";


const  Sidebar = (props) => {
  const WebAssets = useContext(WebAssetsContext);
  const [NavLinktoggle, setNavLinktoggle] = useState(false);

  return (
    
    <>
      
       <div className="main-sidebar sidebar-style-2  sticky">
        <aside id="sidebar-wrapper">
          <div className="sidebar-brand customMiniSmallDeviceparent">
            <NavLink to="/admin/dashboard"> <img width="65" alt={'Logo'}   src={WebAssets.logo} className="header-logo"  /> 
            {/* <span
                className="logo-name">IVOIRE</span> */}
            </NavLink>
            <i  onClick={() => props.minibatToggle() } className="fa fa-arrow-left customMiniSmallDevice"></i>
          </div>
          <ul className="sidebar-menu">
            <li className="menu-header">Main</li>
            <li className="dropdown">
              <NavLink  to="/admin/dashboard"    className="nav-link"><i className="fas fa-tachometer-alt"></i><span>Dashboard</span></NavLink >
            </li>

            <li className="dropdown">
              <NavLink to="/admin/users" className="nav-link"><i className="fas fa-users"></i><span>Customers</span></NavLink>
            </li>

            <li className="dropdown">
              <NavLink to="/admin/products" className="nav-link"><i className="far fa-life-ring"></i><span>Commodity Product</span></NavLink>
            </li>

            <li className="dropdown">
              <NavLink to="/admin/commodity-orders" className="nav-link"><i className="fab fa-first-order"></i><span>Commodity Orders</span></NavLink>
            </li>
            
            
            <li className="dropdown">
              <NavLink to="/admin/commission" className="nav-link"><i className="fas fa-exchange-alt"></i><span>Commission Transactions</span></NavLink>
            </li>

            <li className="dropdown">
              <NavLink to="/admin/transactions" className="nav-link"><i className="fas fa-exchange-alt"></i><span>Transactions</span></NavLink>
            </li>
            <li className="dropdown">
              <NavLink to="/admin/slider" className="nav-link"><i className="fas fa-image"></i><span>Sliders</span></NavLink>
            </li>
            <li className="dropdown">
              <NavLink to="/admin/pages" className="nav-link"><i className="fas fa-copy"></i><span>Pages</span></NavLink>
            </li>

            <li className="dropdown">
              <NavLink to="/admin/settings" className="nav-link"><i className="fas fa-cogs"></i><span>Settings</span></NavLink>
            </li>

            {/* <li className="dropdown">
              <a href="index.html" className="nav-link"><i className="fas fa-piggy-bank"></i><span>Commodity Orders</span></a>
            </li> */}

            {/* <li className="dropdown" key={1} onClick={() => setNavLinktoggle(!NavLinktoggle)}>
              <a href="#" className={ NavLinktoggle == true ? 'menu-toggle nav-link has-dropdown toggled' : 'menu-toggle nav-link has-dropdown' }><i
                  data-feather="briefcase"></i><span>Widgets</span></a>
              {NavLinktoggle && 
                <ul className="dropdown-menu d-block" >
                  <li><a className="nav-link" href="widget-chart.html">Chart Widgets</a></li>
                  <li><a className="nav-link" href="widget-data.html">Data Widgets</a></li>
                </ul>
              }
            </li>
            <li className="dropdown" key={2} onClick={() => setNavLinktoggle(!NavLinktoggle)}>
              <a href="#" className={ NavLinktoggle == true ? 'menu-toggle nav-link has-dropdown toggled' : 'menu-toggle nav-link has-dropdown' }><i
                  data-feather="briefcase"></i><span>Widgets</span></a>
              {NavLinktoggle && 
                <ul className="dropdown-menu d-block" >
                  <li><a className="nav-link" href="widget-chart.html">Chart Widgets</a></li>
                  <li><a className="nav-link" href="widget-data.html">Data Widgets</a></li>
                </ul>
              }
            </li> */}

            
          </ul>
        </aside>
      </div>
    </>

  );
}

export default Sidebar;
